import { Restaurant } from './restaurant.model';

export class TieredRestaurant extends Restaurant {
  priceTierId: string;
  priceTierName?: string;
  isKing: boolean;

  constructor(id: string, name: string, tier: string, isKing: boolean);
  constructor(
    id: string,
    name: string,
    tier: string,
    tierName: string,
    isKing: boolean,
  );
  constructor(restaurant: Restaurant, tier: string, isKing: boolean);
  constructor(
    restaurant: Restaurant,
    tier: string,
    tierName: string,
    isKing: boolean,
  );
  constructor(
    idOrRestaurant: string | Restaurant,
    nameOrTier: string,
    tierOrTierNameOrIsKing?: string | boolean,
    tierNameOrIsKing?: string | boolean,
    isKing?: boolean,
  ) {
    if (typeof idOrRestaurant === 'string') {
      super(idOrRestaurant, nameOrTier);
      this.priceTierId = tierOrTierNameOrIsKing as string;
      if (typeof tierNameOrIsKing === 'string') {
        this.priceTierName = tierNameOrIsKing;
        this.isKing = isKing as boolean;
      } else {
        this.isKing = tierNameOrIsKing as boolean;
      }
    } else {
      super(idOrRestaurant);
      this.priceTierId = nameOrTier;
      if (typeof tierOrTierNameOrIsKing === 'string') {
        this.priceTierName = tierOrTierNameOrIsKing;
        this.isKing = tierNameOrIsKing as boolean;
      } else {
        this.isKing = tierOrTierNameOrIsKing as boolean;
      }
    }
  }
}
